import * as React from 'react';
import { ColorPickerStateContext, parseColor } from 'react-aria-components';

import { Icon } from '@gitbook/spine-icons';
import { assert } from '@gitbook/util-ts';

import { Button, type ButtonProps } from '../Button';

type EyeDropperButtonProps = Pick<ButtonProps, 'size' | 'kind' | 'className'>;

export const EyeDropperButton = React.forwardRef(function EyeDropperButton(
    props: EyeDropperButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>
) {
    const ctx = React.useContext(ColorPickerStateContext);
    assert(ctx, 'EyeDropperButton must be used within a ColorPicker');
    const { setColor } = ctx;

    // Check browser support.
    if (!('EyeDropper' in window) || window.EyeDropper === undefined) {
        return null;
    }

    return (
        <Button
            ref={ref}
            label="Pick a color on the screen"
            iconOnly
            leadingIcon={Icon.EyeDropper}
            kind="secondary"
            onPress={() => {
                // @ts-ignore
                new window.EyeDropper()
                    .open()
                    .then((result) => setColor(parseColor(result.sRGBHex)));
            }}
            {...props}
        />
    );
});
